import { call, put, take, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import services from '../../services';
import * as models from '../../models'; 
import * as actions from './actions';
import * as constants from './constants';
import { AppToastTypes } from 'models/enums'; 
import { userActions } from 'store/user';


export default function* () {
    yield takeEvery(constants.REQUEST_ADJUSTER_DASHBOARD, requestAdjusterDashboard); 
    yield takeEvery(constants.REQUEST_ADJUSTER_INVOICES, requestAdjusterInvoices); 
    yield takeEvery(constants.REQUEST_ADMIN_DASHBOARD, requestAdminDashboard); 
    yield takeEvery(constants.REQUEST_MONTHLY_CLAIM_ACTIVITY, requestMonthlyClaimActivity);     
    yield takeEvery(constants.REQUEST_PAYROLL_DASHBOARD, requestPayrollDashboard); 
}

export function* requestAdjusterDashboard(action: ActionType<typeof actions.requestAdjusterDashboard>): any {
    const userRequest = yield call(services.api.dashboard.getAdjusterDashboard, action.payload.adjusterId, action.payload.invoiceSelector);
    if (userRequest.isSuccess) {
        yield put(actions.receiveAdjusterDashboard(userRequest.data)); 
    }
    else {
        yield put(actions.receiveAdjusterDashboardFailure());
        yield put(userActions.setAppToast({message: `Could not load Adjuster Dashboard: ${userRequest.getError()}`, type: AppToastTypes.Failure}));
    }
}

export function* requestAdjusterInvoices(action: ActionType<typeof actions.requestAdjusterInvoices>): any {
    const userRequest = yield call(services.api.dashboard.getAdjusterInvoices, action.payload.adjusterId, action.payload.invoiceSelector);
    if (userRequest === true) {
        yield put(actions.receiveAdusterInvoices()); 
        yield put(userActions.setAppToast({message: "Export Created", type: AppToastTypes.Success})); 
    }
    else {
        yield put(actions.receiveAdjusterInvoicesFailure());
        yield put(userActions.setAppToast({message: "Could not create invoice export", type: AppToastTypes.Failure}));
    }
}

export function* requestAdminDashboard(action: ActionType<typeof actions.requestAdminDashboard>): any {
    const userRequest = yield call(services.api.dashboard.getAdminDashboard);
    if (userRequest.isSuccess) {
        yield put(actions.receiveAdminDashboard(userRequest.data)); 
    }
    else {
        yield put(actions.receiveAdminDashboardFailure());
        yield put(userActions.setAppToast({message: "Could not load Admin Dashboard", type: AppToastTypes.Failure})); 
    }
}

export function* requestMonthlyClaimActivity(action: ActionType<typeof actions.requestMonthlyClaimActivity>): any {
    const userRequest = yield call(services.api.dashboard.getMonthlyClaimActivity, action.payload.monthsBack, action.payload.months);
    if (userRequest.isSuccess) {
        yield put(actions.receiveMonthlyClaimActivity(userRequest.data)); 
    }
    else {
        yield put(userActions.setAppToast({message: "Could not load monthly claim activity", type: AppToastTypes.Failure}));
    }
}

export function* requestPayrollDashboard(action: ActionType<typeof actions.requestPayrollDashboard>): any {
    const userRequest = yield call(services.api.dashboard.getPayrolLDashboard);
    if (userRequest.isSuccess) {
        yield put(actions.receivePayrollDashboard(userRequest.data)); 
    }
    else {
        yield put(actions.receivePayrollDashboardFailure());
        yield put(userActions.setAppToast({message: "Could not load Payroll Dashboard", type: AppToastTypes.Failure}));
    }
}